import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";

import moment from "moment/moment";
import styles from "./AllowPurchase.module.sass";
import Tooltip from "../../../../components/Tooltip";
import product from "../../../../i11/Product";
import TextInput from "../../../../components/TextInput";

import { useUser } from "../../../../context";
import Dropdown from "../../../../components/Dropdown";

const CryptoList = ["--/--", "HBAR"];
const defCurrency = (currency) => {
	switch (currency) {
		case "GBP":
			return "£";
		case "USD":
			return "$";
		case "HKD":
			return "HK$";
		default:
			return currency || "$";
	}
};

const AllowPurchase = ({ local, setLocal, isDisable }) => {
	const { locale, brand } = useUser();
	const FiatList = ["--/--", brand.defaultCurrency || "USD"]; // "USD", "GBP"
	const [selectFiat, setSelectFiat] = useState(FiatList[0]);
	const [crypto, setCrypto] = useState(CryptoList[0]);
	const [hbarPrice, setHbarPrice] = useState(0);
	const nowDate = moment().format("YYYY-MM-DD HH:mm");
	useEffect(() => {
		if (local.multiPrices && local.multiPrices.length > 0) {
			for (var item of local.multiPrices) {
				if (FiatList.includes(item.currency)) {
					setSelectFiat(item.currency);
				}
				if (CryptoList.includes(item.currency)) {
					setCrypto(item.currency);
				}
			}
		} else {
			setSelectFiat(brand.defaultCurrency || "USD");
		}
		axios
			.get("https://api.coingecko.com/api/v3/coins/hedera-hashgraph", {
				params: {
					localization: false,
					tickers: false,
					community_data: false,
					developer_data: false,
					sparkline: false,
				},
			})
			.then((response) => {
				setHbarPrice(response.data.market_data?.current_price.usd || 0);
			});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const [usdValue, gbpValue, hkdValue, hbarValue] = useMemo(() => {
		if (local.multiPrices && local.multiPrices.length > 0) {
			const multiPrice = (v) =>
				local.multiPrices?.find((e) => e.currency === v)?.price || "";
			const findUSD = multiPrice("USD");
			const findGBP = multiPrice("GBP");
			const findHbar = multiPrice("HBAR");
			const findHKD = multiPrice("HKD");
			return [findUSD, findGBP, findHKD, findHbar];
		}
		return ["", "", "", ""];
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [local]);

	// const cur = selectFiat === "USD" ? usdValue : gbpValue;
	const cur = () => {
		switch (selectFiat) {
			case "USD":
				return usdValue;
			case "GBP":
				return gbpValue;
			case "HKD":
				return hkdValue;
			default:
				return usdValue;
		}
	};

	const calcUsdValue =
		(cur() || 0) *
		(1 - brand?.stripe_processing_fee / 100) *
		(1 - (brand?.meterium_primary_royalty_percent || 1) / 100);

	const FiatFieldRender = () => {
		switch (selectFiat) {
			case "USD":
				return (
					<>
						<TextInput
							className={styles.padd10}
							disabled={isDisable}
							value={usdValue}
							label={`${product[locale].amount} in USD`}
							type="number"
							min="0"
							required
							currency={"$"}
							onChangeInput={(pr) => {
								const item = {
									price: pr,
									currency: "USD",
								};
								setLocal((p) => {
									p.multiPrices[0] = item;
									return {
										...p,
										multiPrices: p.multiPrices,
									};
								});
							}}
						/>
					</>
				);

			case "GBP":
				return (
					<TextInput
						className={styles.padd10}
						disabled={isDisable}
						value={gbpValue}
						label={`${product[locale].amount} in GBP`}
						type="number"
						min="0"
						required
						currency={"£"}
						onChangeInput={(pr) => {
							const item = {
								price: pr,
								currency: "GBP",
							};
							setLocal((p) => {
								p.multiPrices[0] = item;
								return {
									...p,
									multiPrices: p.multiPrices,
								};
							});
						}}
					/>
				);
			case "HKD":
				return (
					<TextInput
						className={styles.padd10}
						disabled={isDisable}
						value={hkdValue}
						label={`${product[locale].amount} in HKD`}
						type="number"
						min="0"
						required
						currency="$"
						onChangeInput={(pr) => {
							const item = {
								price: pr,
								currency: "HKD",
							};
							setLocal((p) => {
								p.multiPrices[0] = item;
								return {
									...p,
									multiPrices: p.multiPrices,
								};
							});
						}}
					/>
				);
			default:
				return <div />;
		}
	};

	const CryptoFieldRender = () => {
		switch (crypto) {
			case "HBAR":
				return (
					<>
						<TextInput
							className={styles.padd10}
							defaultValue={hbarValue}
							disabled={isDisable}
							label={product[locale].hbar}
							type="number"
							min="0"
							required
							currency={"ℏ"}
							onChangeInput={(pr) => {
								const item = {
									price: pr,
									currency: "HBAR",
								};
								setLocal((p) => {
									if (p.multiPrices) {
										p.multiPrices[1] = item;
									} else {
										p.multiPrices = [{}, item];
									}
									return {
										...p,
										multiPrices: p.multiPrices,
									};
								});
							}}
						/>
						<p className={styles.reminder}>
							{product[locale].hbarReminder +
								`' ${nowDate}' is USD≈$${hbarPrice}`}
						</p>
					</>
				);
			default:
				return <div />;
		}
	};

	return (
		<div>
			<div className={styles.border}>
				<div className={styles.title}>
					{product[locale].purchase}
					<Tooltip
						className={styles.tooltip}
						title={product[locale].purchaseTooltip}
						icon="info"
					/>
				</div>
				<div
					style={{
						display: "flex",
						marginTop: "10px",
						gap: "20px",
					}}
				>
					<Dropdown
						isDisabled={isDisable}
						className={styles.dropdown}
						classDropdownLabel={styles.dropdownLabel}
						label={product[locale].fiat}
						value={selectFiat}
						options={FiatList}
						setValue={(v) => {
							if (v === FiatList[0] && crypto === CryptoList[0]) {
								return;
							}
							setLocal((p) => {
								p.multiPrices[0] = {};
								return {
									...p,
									multiPrices: p.multiPrices,
								};
							});
							setSelectFiat(v);
						}}
					/>
					<Dropdown
						isDisabled={isDisable}
						className={styles.dropdown}
						classDropdownLabel={styles.dropdownLabel}
						label={product[locale].crypto}
						value={crypto}
						options={CryptoList}
						setValue={(v) => {
							if (
								v === CryptoList[0] &&
								selectFiat === FiatList[0]
							) {
								return;
							}

							setLocal((p) => {
								if (p.multiPrices && p.multiPrices.length > 0) {
									p.multiPrices[1] = {};
									return {
										...p,
										multiPrices: p?.multiPrices || [],
									};
								}
								return p;
							});
							setCrypto(v);
						}}
					/>
				</div>
				{FiatFieldRender()}
				{selectFiat !== FiatList[0] && (
					<div className={styles.currencyDes}>
						<p>
							{`${product[locale].stripe_processing_fee}: ${
								brand?.stripe_processing_fee || 2.9
							}% + 30¢`}
						</p>
						<p>
							{`${product[locale].primary_purchase_fee}: ${brand?.meterium_primary_royalty_percent}%`}
						</p>
						<p>
							{`${product[locale].potential_earning} ≈ `}
							<span>
								{`${defCurrency(
									selectFiat
								)} ${calcUsdValue.toFixed(3)}`}
							</span>
						</p>
					</div>
				)}
				{CryptoFieldRender()}
			</div>
		</div>
	);
};

export default AllowPurchase;
